import { render } from "./FuellingUsage.vue?vue&type=template&id=35f19657&scoped=true"
import script from "./FuellingUsage.vue?vue&type=script&lang=js"
export * from "./FuellingUsage.vue?vue&type=script&lang=js"

import "./FuellingUsage.vue?vue&type=style&index=0&id=35f19657&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f19657"]])

export default __exports__